import { AccountBookingCard } from '../../components/AccountBookingCard';
import { AccountCTACard } from '../../components/AccountCTACard';
import { CardGrid } from '../../components/CardGrid';
import { space } from '../../theme/tokens';
import {
  Greeting,
  GreetingGroup,
  Page,
  WelcomeMessage,
} from './MyAccountTemplate.styles';
import type { MyAccountTemplateProps } from './MyAccountTemplate.types';

export function MyAccountTemplate({
  greetingName,
  greetingPrefix = 'Hi',
  welcomeMessage,
  booking,
  bookingLabels,
  onEmptyCtaClick,
  ctas,
  isLoading = false,
}: MyAccountTemplateProps) {
  const renderBookingCard = () => {
    if (isLoading) {
      return <AccountBookingCard variant="loading" loadingLabel={bookingLabels.loading} />;
    }
    if (booking) {
      return (
        <AccountBookingCard
          variant="populated"
          imageUrl={booking.imageUrl}
          imageAlt={booking.imageAlt}
          imagePlaceholderLabel={booking.imagePlaceholderLabel}
          status={booking.status}
          statusLabels={bookingLabels.statuses}
          dateLabel={bookingLabels.date}
          dates={booking.dates}
          referenceLabel={bookingLabels.reference}
          reference={booking.reference}
          viewBookingLabel={bookingLabels.view}
          onViewBooking={booking.onViewBooking}
        />
      );
    }
    return (
      <AccountBookingCard
        variant="empty"
        message={bookingLabels.empty}
        ctaLabel={bookingLabels.emptyCta}
        onCtaClick={onEmptyCtaClick}
      />
    );
  };

  return (
    <Page>
      <GreetingGroup>
        <Greeting>
          {greetingPrefix} {greetingName}
        </Greeting>
        <WelcomeMessage>{welcomeMessage}</WelcomeMessage>
      </GreetingGroup>

      {renderBookingCard()}

      <CardGrid $columns={2} $mobileColumns={1} $gap={space[5]} $flushBottom>
        {ctas.map((cta) => (
          <AccountCTACard
            key={cta.id}
            icon={cta.icon}
            title={cta.title}
            description={cta.description}
            onClick={cta.onClick}
            ariaLabel={cta.ariaLabel}
          />
        ))}
      </CardGrid>
    </Page>
  );
}
